module.exports = __webpack_public_path__ + "officialStatic/img/indePre.f6b288b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/indePre.jpg
// module id = NCZR
// module chunks = 0